import React, { useEffect } from 'react';
import {
  MapPin,
  Database,
  Download,
  ShieldCheck,
  CheckCircle2,
  XCircle,
  ArrowRight,
  Target
} from 'lucide-react';
import './Landing.css';
import Apresentacao from './Apresentacao';

export default function Landing({ onLogin }) {
  // Simple scroll to section
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="tl-shell">
      {/* HEADER */}
      <header className="tl-header">
        <div className="tl-container tl-nav">
          <a href="#" className="tl-logo">
            <Target className="tl-logo-icon" size={28} />
            LeadsZone Maps
          </a>
          <div className="tl-nav-links">
            <a href="#como-funciona" onClick={(e) => { e.preventDefault(); scrollTo('como-funciona'); }}>Como Funciona</a>
            <a href="#diferenciais" onClick={(e) => { e.preventDefault(); scrollTo('diferenciais'); }}>Diferenciais</a>
            <a href="https://www.whatszone.app.br" target="_blank" rel="noreferrer" style={{ color: 'var(--tl-cyan)', fontWeight: 'bold', textDecoration: 'none' }}>🚀 WhatsZone</a>
            <button className="tl-btn-primary" onClick={() => onLogin && onLogin()} style={{ padding: '0.6rem 1.5rem' }}>
              Entrar <ArrowRight size={16} />
            </button>
          </div>
        </div>
      </header>

      {/* HERO SECTION */}
      <section className="tl-hero tl-section">
        <div className="tl-hero-bg"></div>
        <div className="tl-hero-grid"></div>
        <div className="tl-container" style={{ position: 'relative', zIndex: 10 }}>
          <h1 className="tl-title text-shimmer">Acesse a Maior Base de Leads.<br />Exporte na hora.</h1>
          <p className="tl-subtitle">
            Filtre nossa base viva por região e segmento. Escolha os leads exatos que você precisa, adicione à sua carteira, pague com segurança e exporte os dados estruturados imediatamente para sua equipe de vendas.
          </p>
          
          <div className="tl-hero-actions">
            <button className="tl-btn-primary" onClick={() => onLogin && onLogin()}>
              Acessar a Base <ArrowRight size={18} />
            </button>
            <button className="tl-btn-secondary" onClick={() => scrollTo('apresentacao')}>
              Ver Apresentação Oficial 🎥
            </button>
          </div>

          {/* Abstract Interface Preview */}
          <div className="tl-hero-preview">
            <div className="tl-preview-header">
              <div className="tl-dot"></div>
              <div className="tl-dot"></div>
              <div className="tl-dot"></div>
            </div>
            <div style={{ display: 'flex', gap: '1rem', textAlign: 'left' }}>
              <div style={{ flex: 1, background: 'rgba(255,255,255,0.02)', padding: '1.5rem', borderRadius: '8px' }}>
                <span style={{ color: '#ef4444', fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '2px' }}>Listas Genéricas</span>
                <div style={{ marginTop: '0.5rem', fontSize: '1rem', color: 'rgba(255,255,255,0.6)' }}>
                  <del>Empresa Fechada LTDA</del><br/>
                  <del>(11) 3333-0000</del> (Fixo)<br/>
                  <del>contato@contabilidade.com</del>
                </div>
              </div>
              <div style={{ flex: 1, background: 'rgba(0,245,196,0.1)', padding: '1.5rem', borderRadius: '8px', border: '1px solid rgba(0,245,196,0.3)' }}>
                <span style={{ color: '#00f5c4', fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '2px', fontWeight: 'bold' }}>Tecnologia LeadsZone</span>
                <div style={{ marginTop: '0.5rem', fontSize: '1.1rem', color: '#fff', fontWeight: 'bold' }}>
                  Clínica Odonto Prime <span style={{fontSize:'0.8rem'}}>⭐ 4.8</span><br/>
                  <span style={{color: '#00f5c4'}}>(11) 99999-9999</span> (WhatsApp)<br/>
                  dr.joao@clinica.com
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS SECTION */}
      <section id="como-funciona" className="tl-section tl-section-alt">
        <div className="tl-container">
          <h2 className="tl-section-title">Busque, Selecione e Exporte</h2>
          <p className="tl-section-desc">O fluxo mais rápido para abastecer o seu CRM. Você tem controle total sobre quais leads comprar.</p>
          
          <div className="tl-features-grid">
            <div className="tl-feature-card">
              <div className="tl-feature-icon">
                <MapPin />
              </div>
              <h3>Busca Cirúrgica</h3>
              <p>Acesse um painel inteligente e filtre leads por estado, fontes e segmento comercial. Nossa base já foi mapeada com alta precisão.</p>
            </div>
            
            <div className="tl-feature-card">
              <div className="tl-feature-icon">
                <Database />
              </div>
              <h3>Dados Sempre Atualizados</h3>
              <p>Diga adeus às planilhas poluídas. Nossa base passa por uma rigorosa higienização contínua para garantir informações estruturadas e sem duplicatas.</p>
            </div>
            
            <div className="tl-feature-card">
              <div className="tl-feature-icon">
                <Download />
              </div>
              <h3>Compra e Exportação Imediata</h3>
              <p>Adicione os leads na sua carteira, realize o pagamento com 100% de segurança via <strong>Stripe</strong> e o download do CSV é liberado na mesma hora. Sem aguardar dias por entregas.</p>
            </div>
          </div>
          
          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <a href="/apresentacao" target="_blank" rel="noopener noreferrer" className="tl-btn-secondary" style={{ display: 'inline-flex', padding: '1rem 2rem', fontSize: '1.1rem', textDecoration: 'none' }}>
              Veja Nossa Tecnologia Por Dentro <ArrowRight size={18} style={{ marginLeft: '10px' }} />
            </a>
          </div>
        </div>
      </section>

      {/* COMPARISON SECTION */}
      <section id="diferenciais" className="tl-section">
        <div className="tl-container">
          <h2 className="tl-section-title">O Padrão Ouro em Leads</h2>
          <p className="tl-section-desc">Veja a diferença entre depender de listas frias obsoletas e extrair inteligência em tempo real direto da fonte.</p>

          <div className="tl-comparison">
            {/* The Old Way */}
            <div className="tl-comp-card tl-comp-them">
              <h3 style={{ color: '#ff4d4d', fontSize: '1.5rem', marginBottom: '0.5rem' }}>Bancos Genéricos</h3>
              <p style={{ color: 'rgba(255,255,255,0.5)', marginBottom: '2rem' }}>A forma antiga de prospectar.</p>
              <ul className="tl-comp-list">
                <li><XCircle color="#ff4d4d" /> <span>Listas recicladas e desatualizadas.</span></li>
                <li><XCircle color="#ff4d4d" /> <span>Contatos frequentemente caem em contabilidades.</span></li>
                <li><XCircle color="#ff4d4d" /> <span>Zero adequação geográfica fina (apenas "Estado/Cidade").</span></li>
                <li><XCircle color="#ff4d4d" /> <span>Requer horas de limpeza no Excel antes do uso.</span></li>
              </ul>
            </div>

            {/* LeadsZone Maps Way */}
            <div className="tl-comp-card tl-comp-us">
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: 'rgba(0,240,255,0.1)', color: 'var(--tl-cyan)', padding: '5px 12px', borderRadius: '50px', fontSize: '0.8rem', fontWeight: 'bold', marginBottom: '1rem' }}>
                <ShieldCheck size={16} /> COMPRA GARANTIDA
              </div>
              <h3 style={{ color: 'var(--tl-cyan)', fontSize: '2rem', marginBottom: '0.5rem' }}>LeadsZone Maps</h3>
              <p style={{ color: 'var(--tl-text-muted)', marginBottom: '2rem' }}>A precisão tecnológica que seu time de vendas exige.</p>
              <ul className="tl-comp-list">
                <li><CheckCircle2 color="var(--tl-cyan)" /> <span>Base exclusiva, higienizada e atualizada continuamente pela nossa tecnologia.</span></li>
                <li><CheckCircle2 color="var(--tl-cyan)" /> <span>Informações direto do cadastro do dono do negócio.</span></li>
                <li><CheckCircle2 color="var(--tl-cyan)" /> <span>Filtros avançados e seleção minuciosa direto no seu painel.</span></li>
                <li><CheckCircle2 color="var(--tl-cyan)" /> <span>Entregue higienizado, pronto pro PipeDrive/RD Station.</span></li>
              </ul>
              
              <button className="tl-btn-primary" onClick={() => onLogin && onLogin()} style={{ width: '100%', justifyContent: 'center', marginTop: '2rem' }}>
                Quero essa precisão <ArrowRight size={18} />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* APRESENTAÇÃO EMBARCADA */}
      <div id="apresentacao" style={{ position: 'relative', zIndex: 10, background: '#020818' }}>
        <Apresentacao embedded={true} />
      </div>

      {/* FOOTER */}
      <footer className="tl-footer">
        <div className="tl-container">
          <div className="tl-logo" style={{ justifyContent: 'center' }}>
            <Target className="tl-logo-icon" size={24} /> LeadsZone Maps
          </div>
          <p>© 2026. Todos os direitos reservados. Software em conformidade com a LGPD e termos do Google.</p>
        </div>
      </footer>
    </div>
  );
}
